import React from 'react'
import { useNavigate } from "react-router-dom";
const Thanks = () => {
  const navigate = useNavigate();

  const handleHome =()=>{
    navigate("/")
  }
  return (
    <div>
      <div className="jumbotron text-center thanks">
        <h1 className="display-3">Thank You For Join To Miirza!</h1>
        <p className="lead"><strong> Wait until your email is verified.</strong></p>
        <hr />
        <p className="lead">
          <div className="btn btn-primary btn-sm" onClick={handleHome}>Continue to homepage</div>
        </p>
      </div>
    </div>
    
  )
}

export default Thanks